import React from 'react';
import { AlertTriangle, AlertCircle, CheckCircle, Info, X } from 'lucide-react';
import './ConfirmModal.css';

const ConfirmModal = ({ 
    isOpen, 
    title, 
    message, 
    onConfirm, 
    onCancel, 
    confirmText = 'Підтвердити', 
    cancelText = 'Скасувати',
    isAlert = false,
    type = 'danger'
}) => {
    if (!isOpen) return null;

    const getIcon = () => {
        const iconSize = 22;
        switch (type) {
            case 'danger':
                return <AlertTriangle size={iconSize} className="confirm-icon icon-danger" />;
            case 'warning':
                return <AlertCircle size={iconSize} className="confirm-icon icon-warning" />;
            case 'success':
                return <CheckCircle size={iconSize} className="confirm-icon icon-success" />;
            case 'primary':
            case 'info':
            default:
                return <Info size={iconSize} className="confirm-icon icon-info" />;
        }
    };

    const getButtonClass = () => {
        switch (type) {
            case 'danger':
                return 'confirm-btn-danger';
            case 'success':
                return 'confirm-btn-success';
            case 'warning':
                return 'confirm-btn-warning';
            case 'primary':
            case 'info':
            default:
                return 'confirm-btn-primary';
        }
    };

    return (
        <div className="confirm-modal-overlay">
            <div className={`confirm-modal-content border-${type}`}>
                <div className="confirm-modal-header">
                    <div className="confirm-title-wrapper">
                        {getIcon()}
                        <h3>{title || (isAlert ? 'Сповіщення' : 'Підтвердження дії')}</h3>
                    </div>
                    <button className="confirm-modal-close" onClick={onCancel || onConfirm} title="Закрити">
                        <X size={18} />
                    </button>
                </div>
                <div className="confirm-modal-body">
                    <p>{message || 'Ви впевнені, що хочете виконати цю дію?'}</p>
                </div>
                <div className="confirm-modal-footer">
                    {!isAlert && (
                        <button className="confirm-btn-cancel" onClick={onCancel}>
                            {cancelText}
                        </button>
                    )}
                    <button className={getButtonClass()} onClick={onConfirm}>
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
